export const App = {
  Components: {},
  Ui: {},
}

window.App = App
